import { Claim, ClaimStatus } from '@dataTypes/claimFeature.types'

export const isClaimApproved = (claim: Claim): boolean =>
  claim.status === ClaimStatus.Approved ||
  claim.status === ClaimStatus.PartiallyApproved
